<template>
  <base-iframe
    height="100%"
    :params="{ canvas: 'true', currencyCode, model }"
    :src="`https://${origin}.vans.com/${slug}/index.html`"
    style="background: #f1f2ed"
    :title="$t.customs.title"
    width="100%"
    @message="({ data: { command } }) => $emit(command)"
  />
</template>

<script lang="ts" setup>
const props = defineProps<{
  model?: string | string[]
  customsFlow?: string | string[]
}>()

defineEmits<{
  'close-iframe': []
  'customs-tool-loaded': []
  'customs-product-added-to-cart': []
  'start-over': []
  'toggle-header': []
}>()

const { configCustomsUrls } = useFeatureFlags()
const { targetEnv } = useRuntimeConfig().public
const currencyCode = getCurrencySymbol(useLocale(), useCurrencyCode())

const env = {
  DEV: 'dev',
  QA: 'qa2',
  PREPROD: 'preprod2',
  PROD: 'prod'
}[targetEnv]

const origin = {
  DEV: 'dev3',
  QA: 'qa3',
  PREPROD: 'preprod3',
  PROD: 'www'
}[targetEnv]

// The `configCustomsUrls` feature flag supplies the resolved app-slug per environment,
// so it can swap the Vans Customizer between the legacy `vfdp-customizer-nora-{env}` build
// and the new `vans-customizer-v2-{env}` build (or repoint the Toolkit) without a code change.
const fallbackSlug = `vfdp-${props.customsFlow ? 'customs-toolkit' : 'customizer-nora'}-${env}`
const slug = computed(() => (
  props.customsFlow ? configCustomsUrls?.toolkit : configCustomsUrls?.customizer) || fallbackSlug
)
</script>
